import { parseAsString, useQueryState } from "nuqs";

export const usePatientUserIdFromUrl = () => {
  return useQueryState("patientUserId", parseAsString);
};
